module.exports = __webpack_public_path__ + "static/media/Item-List-Management.5653ad8f.svg";